// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .afterpay-ghost-button {
    opacity: 0;
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    cursor: pointer;
  }
`;

export default styles;
